module.exports = __webpack_public_path__ + "static/media/previous-mobile.ea700026.png";